import { connect } from "react-redux"
import { Dispatch } from "redux"
import { ChatRoom } from "../../../../rpcs/dist/ChatRoomRPC"
import { ContentActionDispatcher } from "../../actiondispacher/content-action-dispacher"
import { RootState, ReduxAction } from "../../../../reducers"
import { IEditorContent } from "../../types"

export interface IContainerProps {
  contents: IEditorContent[] | null
  chatRoom: ChatRoom
  actions: ContentActionDispatcher
}

const mapStateToProps = ({
  pages,
}: RootState): Omit<IContainerProps, "actions"> => ({
  contents: pages.editor.currentEditingState.contents,
  chatRoom: pages.editor.fetchData.episode!.chatRoom,
})

const mapDispatchToProps = (
  dispatch: Dispatch<ReduxAction>,
): Pick<IContainerProps, "actions"> => ({
  actions: new ContentActionDispatcher(dispatch),
})

export const container = connect(mapStateToProps, mapDispatchToProps)
